import { connect } from 'react-redux';
import { appActions } from '../../reducers/app.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import Popup from '../modal/Popup.modal';
var MobileMenuItem = function MobileMenuItem(_ref) {
  var title = _ref.title,
    internalUrl = _ref.internalUrl,
    externalUrl = _ref.externalUrl,
    popup = _ref.popup,
    toggleHamburgerMenuAction = _ref.toggleHamburgerMenuAction,
    showModalAction = _ref.showModalAction;
  var navigate = useNavigate();
  return /*#__PURE__*/React.createElement("div", {
    className: "mm-item",
    onClick: function onClick() {
      if (internalUrl) navigate(internalUrl);
      if (externalUrl) window.open(externalUrl, '_blank');
      if (popup) {
        showModalAction({
          component: /*#__PURE__*/React.createElement(Popup, {
            popupID: popup
          })
        });
      }
      toggleHamburgerMenuAction();
    }
  }, /*#__PURE__*/React.createElement("p", null, title));
};
var mdtp = {
  showModalAction: modalActions.show,
  toggleHamburgerMenuAction: appActions.toggleHamburgerMenu
};
export default connect(null, mdtp)(MobileMenuItem);